import React from 'react'

const favouriteHero = props => {
    return (
        <div style={{display: 'block'}} className="tab-pane active show fade" id="favorite_hero" role="tabpanel" aria-labelledby="favorite_hero_tab">
            <h4 className="mt-0 theme_semibold">favorite_hero</h4>
        </div>
    )
}

export default favouriteHero